import { Box, Button, styled, Typography } from "@mui/material";
import { MatxLayoutSettings } from "app/components/MatxLayout/settings";
import { useNavigate } from "react-router-dom";

// STYLED COMPONENTS
const FlexBox = styled(Box)({
  display: "flex",
  alignItems: "center"
});

const JustifyBox = styled(FlexBox)({
  maxWidth: 320,
  flexDirection: "column",
  justifyContent: "center"
});

const IMG = styled("img")({
  width: "100%",
  marginBottom: "32px"
});

const NotFoundRoot = styled(FlexBox)({
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh !important"
});

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <NotFoundRoot>
      <JustifyBox>
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            color: MatxLayoutSettings?.palette?.black,
            mt: 2,
            mb: 2,
            fontSize: "25px",
            fontWeight: "500",
          }}
        >
          PAGE NOT FOUND
        </Typography>

        <IMG src="/assets/images/illustrations/404.svg" alt="" />

        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            color: MatxLayoutSettings?.palette?.black,
            mt: 2,
            mb: 2,
            fontSize: "16px",
            fontWeight: "500",
          }}
        >
          We can't find the page you're looking for!
        </Typography>

        {/* <Button
          color="primary"
          variant="contained"
          sx={{ textTransform: "capitalize" }}
          onClick={() => navigate(-1)}>
          Go Back
        </Button> */}
      </JustifyBox>
    </NotFoundRoot>
  );
}
